<template>
  <div>
    <!-- <Snackbar ref="snackbar" /> -->
    <Snackbar :show="mostrarSnackbar" />

    <router-view />
    <RefExtras v-if="isMainRoute" />
    <ChatsHelexium />
  </div>
</template>
<script>
import Snackbar from "@/components/helexium/Snackbar.vue";
import RefExtras from "@/components/RefExtras/RefExtras.vue";
import ChatsHelexium from "@/views/Helexium/Assistant/ChatsHelexium.vue";
// import 'line-awesome/dist/line-awesome/css/line-awesome.min.css'
// import 'remixicon/fonts/remixicon.css'
export default {
  components: {
    Snackbar,
    RefExtras,
    ChatsHelexium,
  },
  sockets: {
    connect: function () {
      console.log("conectado a cockets. en app.vue***************************************************************");
    },
    nuevo_mensaje: async function (data) {
      let usuario = JSON.parse(localStorage.getItem("setPersonaAct")) || null;
      console.log(data);
      if (usuario != null) {
        if (data.ParaId == usuario.id) {
          // alert("has recibido respuesta en ticket");
          this.showToast("success", "Has recibido respuesta de ticket");

          //console.log(data)
          // Push.Permission.get()
          // Push.create('Orden sin driver asignado!', {
          //   //Titulo de la notificación
          //   body: data.descripcion, //Texto del cuerpo de la notificación
          //   icon: 'https://admin.appyaqui.com/img/yaqui.7c8b493b.jpg', //Icono de la notificación
          //   timeout: 6000, //Tiempo de duración de la notificación
          // })
        } else {
          if (data.ParaId == null && usuario.rol.nivel == 4) {
            this.showToast("success", "Admin!, tienes nuevo mensaje ticket!");
          }
        }
      }
    },
  },
  name: "App",
  data() {
    return {
      usuario: {},
      mostrarSnackbar: false,
    };
  },
  mounted() {
    if (this.$store.state.hl_url === "https://bupewebprodapi.azurewebsites.net/api/") {
      // this.bloquearMenuDesarrollador();
    }
    console.log("init app");
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    // let html = document.querySelector("html");
    // html.classList.add("skytheme");

    //console.log('cargando modo oscuro en mounted app')
    this.checkVersion();
  },
  computed: {
    isMainRoute() {
      return this.$route.name === "auth.login";
    },
  },
  methods: {
    bloquearMenuDesarrollador() {
      let minimalUserResponseInMiliseconds = 200;
      function check() {
        // console.clear();
        let before = new Date().getTime();
        debugger;
        let after = new Date().getTime();
        if (after - before > minimalUserResponseInMiliseconds) {
          document.write("Dont open Developer Tools.");
          self.location.replace(window.location.protocol + window.location.href.substring(window.location.protocol.length));
        }
        setTimeout(check, 100);
      }
      check();

      document.addEventListener("contextmenu", (e) => e.preventDefault());
      document.addEventListener("keydown", (e) => {
        if (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) e.preventDefault();
        if (e.keyCode === 83 && (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)) e.preventDefault();
        if (e.ctrlKey && e.keyCode === 85) e.preventDefault();
        if (e.keyCode === 123) e.preventDefault();
      });
    },
    checkVersion() {
      fetch("/version.json", { cache: "no-cache" })
        .then((response) => response.json())
        .then((data) => {
          const newVersion = data.version;
          const currentVersion = localStorage.getItem("version");
          if (currentVersion && newVersion !== currentVersion) {
            // this.$refs.snackbar.show(); // Muestra el snackbar
            this.mostrarSnackbar = true;
          }
          localStorage.setItem("version", newVersion);
        })
        .catch((err) => console.error("Error al verificar versión", err));
    },
    // checkVersion() {
    //   // Simula una nueva versión para probar el snackbar
    //   setTimeout(() => {
    //     this.mostrarSnackbar = true;

    //     // this.$refs.snackbar.show(); // Muestra el snackbar después de un retraso (para prueba)
    //   }, 2000); // Lo muestra después de 2 segundos
    // },
    showToast(type, message) {
      console.log(type);

      const opcionesBase = {
        position: "top-center",
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
        draggable: false,
        draggablePercent: 0.41,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
        rtl: false,
      };

      const tipos = {
        success: {
          metodo: this.$toast.success,
          timeout: 2984,
        },
        error: {
          metodo: this.$toast.error,
          timeout: 1992,
        },
        warning: {
          metodo: this.$toast.warning,
          timeout: 2984,
        },
      };

      if (tipos[type]) {
        tipos[type].metodo(message, {
          ...opcionesBase,
          timeout: tipos[type].timeout,
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "./assets/scss/backend.scss";
@import "./assets/scss/frontend.scss";
@import "./assets/css/custom.css";

body {
  background-color: $bodybg;
  font-size: 12px;
}
</style>
